/* eslint-disable */
import { Box, Skeleton } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Button, Col, Flex, Form, Row, Select, Spin } from 'antd';
import comptroller from 'assets/images/comptroller_white.svg';
import AntdValuePreview from 'components/dev/AntdValuePreview';
import DetailPageHeader from 'components/header/DetailPageHeader';
import InputLabel from 'components/InputLabel/index';
import CustomTextInput from 'components/inputs/CustomTextInput';
import CustomSelectInput from 'components/inputs/CustomSelectInput';
import MainCard from 'components/MainCard';
import { toastConfig } from 'config';
import { isEmpty } from 'lodash';
import ComptrollerConfirmModal from 'pages/comptroller/ComptrollerConfirmModal';
import { filterChildOptionLabel } from 'pages/globals/global';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useGetLynFormDataMutation } from 'store/features/comptroller/comptrollerApi';
import { useGetLynFormPropertyMutation, useGetSingleIdentityMutation } from 'store/features/process/processApi';

export const assurerAndControlOwnerOptions = [
	{ key: 1, label: 'Position', value: 'DATA_positionList' },
	{ key: 2, label: 'Process Role', value: 'DATA_processRoleList' },
	{ key: 3, label: 'PGR', value: 'DATA_PGRList' },
];

export const controlCategoryOptions = [
	{ key: 1, label: 'Key control', value: 'Key control' },
	{ key: 2, label: 'Non-key control', value: 'Non-key control' },
];

function Create() {
	const theme = useTheme();
	const [form] = Form.useForm();

	const { state } = useLocation();
	const navigate = useNavigate();

	const [showModal, setShowModal] = useState(false);
	const [submitData, setSubmitData] = useState();

	const [GetSingleIdentity, { error: errorData, isSuccess: isSingleCaseSuccess, isLoading: isSingleCaseLoading, isError: isSingleCaseError }] =
		useGetSingleIdentityMutation();

	const onSubmitHandler = (payload) => {
		// console.log('payload', payload);
		setSubmitData(payload);
		setShowModal(true);
	};

	const onModalOkHandler = () => {
		GetSingleIdentity({
			operation: 'add-single',
			processCode: state?.processCode,
			suffixCode: '',
			data: submitData,
		});
	};

	useEffect(() => {
		if (isSingleCaseSuccess) {
			toast.success('Success! Action completed ', toastConfig);
			navigate(-1);
		}

		if (isSingleCaseError) {
			if (errorData?.data?.code === '501') {
				toast.error(errorData?.data?.message, toastConfig);
			} else {
				toast.error('Failed! Action not completed', toastConfig);
			}
		}
	}, [isSingleCaseSuccess, isSingleCaseError, errorData]);

	useEffect(() => {
		if (isEmpty(state?.processCode)) {
			navigate(-1);
		}
	}, [state?.processCode]);

	return (
		<Box>
			<DetailPageHeader title={'Create ' + (state?.processName ?? '')} />

			<Spin spinning={isSingleCaseLoading} style={{ maxHeight: '100%' }}>
				<MainCard>
					<Form form={form} layout="vertical" onFinish={onSubmitHandler} autoComplete="off" requiredMark={false}>
						<AntdValuePreview form={form} show={false} />

						<Row gutter={[16, 0]}>
							<Col xs={24} md={6} lg={6} xl={4}>
								<InputLabel label="Control Domain" head={true} />
							</Col>
							<Col xs={24} md={18} lg={18} xl={8}>
								<NonDependantSelect name="DATA_controlDomain" code="DATA_controlDomain" displayNameCode="DATA_controlDomain_label" />
							</Col>

							<Col xs={24} md={6} lg={6} xl={4}>
								<InputLabel label="Control Sub-Domain" head={true} />
							</Col>
							<Col xs={24} md={18} lg={18} xl={8}>
								<NonDependantSelect
									name="DATA_controlSubDomain"
									code="DATA_controlSubDomain"
									displayNameCode="DATA_controlSubDomain_label"
								/>
							</Col>

							<Col xs={24} md={6} lg={6} xl={4}>
								<InputLabel label="Control Description" head={true} />
							</Col>
							<Col xs={24} md={18} lg={18} xl={20}>
								<CustomTextInput
									name="controlQuestion"
									placeholder="Write here"
									rules={[
										{
											required: true,
											message: 'Field is required',
										},
									]}
								/>
							</Col>

							<Col xs={24} md={6} lg={6} xl={4}>
								<InputLabel label="Control Owner - by Identity" head={true} />
							</Col>
							<Col xs={24} md={18} lg={6} xl={8}>
								<Form.Item
									name="ownerIdentityType"
									rules={[
										{
											required: true,
											message: 'Field is required',
										},
									]}
								>
									<Select
										showSearch
										allowClear
										style={{ width: '100%' }}
										filterOption={true}
										onChange={() => form.setFieldValue('ownerIdentityValue')}
										placeholder="Select from the list"
										optionFilterProp="children"
									>
										{assurerAndControlOwnerOptions?.map(({ key, value, label }) => (
											<Select.Option key={key} value={value}>
												{label}
											</Select.Option>
										))}
									</Select>
								</Form.Item>
							</Col>

							<Col xs={24} md={6} lg={6} xl={4}>
								<InputLabel label="Control Owner - Identity Value" head={true} />
							</Col>
							<Col xs={24} md={18} lg={6} xl={8}>
								<Form.Item
									noStyle
									shouldUpdate={(previousValue, currentValue) =>
										previousValue?.ownerIdentityType !== currentValue?.ownerIdentityType
									}
								>
									{({ getFieldValue }) => (
										<DependantSelect
											name="ownerIdentityValue"
											displayNameCode="ownerIdentityLabel"
											code={getFieldValue('ownerIdentityType')}
											isDependent={true}
											rules={[
												{
													required: true,
													message: 'Field is required',
												},
											]}
										/>
									)}
								</Form.Item>
							</Col>

							<Col xs={24} md={6} lg={6} xl={4}>
								<InputLabel label="Control Category" head={true} />
							</Col>
							<Col xs={24} md={18} lg={18} xl={8}>
								<CustomSelectInput name="controlCategory">
									{controlCategoryOptions?.map((item, index) => (
										<Select.Option key={index} value={item?.value}>
											{item?.value}
										</Select.Option>
									))}
								</CustomSelectInput>
							</Col>

							<Col xs={24} md={6} lg={6} xl={4}>
								<InputLabel label="Control ID" head={true} />
							</Col>
							<Col xs={24} md={18} lg={18} xl={8}>
								<CustomTextInput disabled={true} name="controlId" value="To be system generated" />
							</Col>

							{/* <Col xs={24} md={4} xl={4}>
								<InputLabel label="Effective Date" head={true} />
							</Col>
							<Col xs={24} md={18} xl={20}>
								<Form.Item name="effectiveDate">
									<DatePicker disabledDate={disablePastDates} style={{ width: '100%' }} />
								</Form.Item>
							</Col> */}

							<Col xs={24}>
								<Flex justify="end">
									<Button type="primary" htmlType="submit" style={{ backgroundColor: theme.palette.lynTheme.main }}>
										Submit
									</Button>
								</Flex>
							</Col>
						</Row>
					</Form>
				</MainCard>
			</Spin>

			{showModal && (
				<ComptrollerConfirmModal
					showModal={showModal}
					modalData={{
						head: state?.processName ?? '',
						label: 'Do you want to proceed?',
					}}
					setShowModal={setShowModal}
					handleSubmit={onModalOkHandler}
				/>
			)}
		</Box>
	);
}

export default Create;

export const DependantSelect = ({ label, size = 'large', name, displayNameCode, code, rules, isDependent = false, processCode }) => {
	const form = Form.useFormInstance();
	const userId = useSelector((state) => state.profile.profileData.userId);
	const companyCode = useSelector((state) => state.profile.profileData.creatorOrganizationId);
	const { state } = useLocation();

	const [options, setOptions] = useState(isDependent ? [] : null);

	const [GetLynFormData, { data: lynFormData }] = useGetLynFormDataMutation();
	const [GetLynFormProperty, { data: lynProperty }] = useGetLynFormPropertyMutation();

	const onSelectHandler = (value) => {
		if (displayNameCode) {
			const label = form.getFieldValue(value);
			form.setFieldValue(displayNameCode, label);
		}
	};

	useEffect(() => {
		if (code?.startsWith('PROPERTY_')) {
			GetLynFormProperty({
				type: 'FORM',
				fieldCode: state?.processCode || processCode,
				propertyCode: code,
				companyCode,
				processVersion: state?.processVersion,
				status: 'Active',
			});
		} else if (code?.startsWith('DATA_')) {
			const queryName = code.replace('DATA_', '');
			GetLynFormData({
				name: queryName,
				userId,
			});
		}
	}, [code, userId]);

	useEffect(() => {
		if (lynProperty?.lynProperties?.length > 0) {
			setOptions(lynProperty?.lynProperties);
			lynProperty?.lynProperties?.forEach((value) => {
				form.setFieldsValue({
					[value?.propertyValue]: value?.displayName,
				});
			});
		}

		if (lynFormData?.results?.length > 0) {
			setOptions(lynFormData?.results);
			lynFormData?.results?.forEach((value) => {
				form.setFieldsValue({
					[value?.propertyValue]: value?.displayName,
				});
			});
		}
	}, [lynProperty, lynFormData]);

	return (
		<>
			<Form.Item label={label} name={name} rules={rules}>
				{options === null ? (
					<Skeleton variant="text" sx={{ fontSize: '1rem', marginX: 1 }} />
				) : (
					<Select
						allowClear
						style={{ width: '100%' }}
						showSearch
						filterOption={filterChildOptionLabel}
						onSelect={onSelectHandler}
						placeholder="Select from the list"
						autoComplete="off"
						size={size}
					>
						{options?.map((value, index) => (
							<Select.Option key={index} value={value?.propertyValue}>
								{value?.displayName}
							</Select.Option>
						))}
					</Select>
				)}
			</Form.Item>
			<Form.Item noStyle name={displayNameCode} />
		</>
	);
};

export const NonDependantSelect = ({ label, name, size = 'large', code, displayNameCode, processCode }) => {
	const form = Form.useFormInstance();
	const userId = useSelector((state) => state.profile.profileData.userId);
	const companyCode = useSelector((state) => state.profile.profileData.creatorOrganizationId);
	const { state } = useLocation();

	const [options, setOptions] = useState(null);

	const [GetLynFormData, { data: lynFormData }] = useGetLynFormDataMutation();
	const [GetLynFormProperty, { data: lynProperty }] = useGetLynFormPropertyMutation();

	const onSelectHandler = (value, obj) => {
		if (obj?.children) {
			form.setFieldValue(displayNameCode, obj?.children);
		}
	};

	useEffect(() => {
		if (code?.startsWith('PROPERTY_')) {
			GetLynFormProperty({
				type: 'FORM',
				fieldCode: state?.processCode || processCode,
				propertyCode: code,
				companyCode,
				processVersion: state?.processVersion,
				status: 'Active',
			});
		} else if (code?.startsWith('DATA_')) {
			const queryName = code.replace('DATA_', '');
			GetLynFormData({
				name: queryName,
				userId,
			});
		}
	}, [code, userId]);

	// Store options code & displayName in form.
	useEffect(() => {
		if (lynProperty?.lynProperties?.length > 0) {
			setOptions(lynProperty?.lynProperties);
			lynProperty?.lynProperties?.forEach((value) => {
				form.setFieldsValue({
					[value?.propertyValue]: value?.displayName,
				});
			});
		}

		if (lynFormData?.results?.length > 0) {
			setOptions(lynFormData?.results);
			lynFormData?.results?.forEach((value) => {
				form.setFieldsValue({
					[value?.propertyValue]: value?.displayName,
				});
			});
		}
	}, [lynProperty, lynFormData]);

	return (
		<>
			<Form.Item
				label={label}
				name={name}
				rules={[
					{
						required: true,
						message: 'Field is required',
					},
				]}
			>
				<Select
					allowClear
					showSearch
					size={size}
					style={{ width: '100%' }}
					onSelect={onSelectHandler}
					filterOption={filterChildOptionLabel}
					placeholder="Select from the list"
				>
					{options === null ? (
						<Skeleton variant="text" sx={{ fontSize: '1rem', marginX: 1 }} />
					) : (
						options?.map((value, index) => (
							<Select.Option key={index} value={value?.propertyValue}>
								{value?.displayName}
							</Select.Option>
						))
					)}
				</Select>
			</Form.Item>
			<Form.Item noStyle name={displayNameCode} />
		</>
	);
};
